import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function Ponto() {
    const navigate = useNavigate();
    const location = useLocation();

    // Determina o valor da aba com base no caminho atual da URL
    let value = 0;
    if (location.pathname.endsWith('/funcionarios')) {
        value = 1;
    } else if (location.pathname.endsWith('/escala')) { // Agora verifica a rota '/online'
        value = 2;
    } else if (location.pathname.endsWith('/fechar')) { // Agora verifica a rota '/online'
        value = 3;
    } else if (location.pathname.endsWith('/csv')) { // Agora verifica a rota '/online'
        value = 4;
    } else if (location.pathname.endsWith('/ponto-xlsx')) { // Agora verifica a rota '/online'
        value = 5;
    } else if (location.pathname.endsWith('/periodo')) { // Agora verifica a rota '/online'
        value = 6;
    } else if (location.pathname.endsWith('/adiantamento')) { // Agora verifica a rota '/online'
        value = 7;
    } else if (location.pathname.endsWith('/falta')) { // Agora verifica a rota '/online'
        value = 8;
    } else if (location.pathname.endsWith('/editar')) { // Agora verifica a rota '/online'
        value = 9;
    }
    // Se a rota for '/producao/gerar', o valor padrão (0) é mantido.

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            navigate('/ponto/ponto');
        } else if (newValue === 1) {
            navigate('/ponto/funcionarios');
        } else if (newValue === 2) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/escala');
        } else if (newValue === 3) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/fechar');
        } else if (newValue === 4) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/csv');
        } else if (newValue === 5) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/ponto-xlsx');
        } else if (newValue === 6) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/periodo');
        } else if (newValue === 7) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/adiantamento');
        } else if (newValue === 8) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/falta');
        } else if (newValue === 9) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/ponto/editar');
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="Abas de Produção">
                    <Tab label="Ponto" />
                    <Tab label="Funcionários" />
                    <Tab label="Escala" />
                    <Tab label="Fechar" />
                    <Tab label="CSV" />
                    <Tab label="XLSX" />
                    <Tab label="Período" />
                    <Tab label="Adiantamento" />
                    <Tab label="Falta" />
                    <Tab label="Editar" />
                </Tabs>
            </Box>
            {/* O Outlet renderizará o conteúdo do componente da rota aninhada */}
            <Outlet />
        </Box>
    );
}